'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable max-len */

var GraphicViolence = function (_BcReactComponent) {
  _inherits(GraphicViolence, _BcReactComponent);

  function GraphicViolence() {
    _classCallCheck(this, GraphicViolence);

    return _possibleConstructorReturn(this, (GraphicViolence.__proto__ || Object.getPrototypeOf(GraphicViolence)).apply(this, arguments));
  }

  _createClass(GraphicViolence, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        { focusable: 'false', 'aria-hidden': true, className: 'icon-svg-graphic-violence', preserveAspectRatio: 'xMinYMin meet', viewBox: '0 0 16 16' },
        _react2.default.createElement('path', { className: 'path1', d: 'M15.707 14.293l-3.146-3.146 2.293-2.293c0.195-0.195 0.195-0.512 0-0.707l-1-1c-0.195-0.195-0.512-0.195-0.707 0l-1.646 1.646-8.646-8.646c-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v2c0 0.133 0.053 0.26 0.146 0.354l8.646 8.646-1.646 1.646c-0.195 0.195-0.195 0.512 0 0.707l1 1c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2.293-2.293 3.146 3.146c0.39 0.391 1.024 0.391 1.414 0s0.39-1.024 0-1.414zM9.5 11l-8.75-8.75 0.5-0.5 8.75 8.75-0.5 0.5z' })
      );
    }
  }]);

  return GraphicViolence;
}(_baseBcReactComponent2.default);

exports.default = GraphicViolence;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/GraphicViolence/GraphicViolence.js
// module id = 239
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16